import React, { createContext, useContext, ReactNode } from 'react';

interface DataRefreshContextType {
  // Function to refresh all companies data in AdminViewPage
  refreshCompanies?: () => Promise<void>;
  // Function to refresh users data in AdminViewPage
  refreshUsers?: () => Promise<void>;
  // Function to refresh all admin data (companies + users)
  refreshAllData?: () => Promise<void>;
}

const DataRefreshContext = createContext<DataRefreshContextType>({});

export const useDataRefresh = () => {
  return useContext(DataRefreshContext);
};

interface DataRefreshProviderProps {
  children: ReactNode;
  refreshCompanies?: () => Promise<void>;
  refreshUsers?: () => Promise<void>;
  refreshAllData?: () => Promise<void>;
}

export const DataRefreshProvider: React.FC<DataRefreshProviderProps> = ({
  children,
  refreshCompanies,
  refreshUsers,
  refreshAllData
}) => {
  const value: DataRefreshContextType = {
    refreshCompanies,
    refreshUsers,
    refreshAllData
  };

  return (
    <DataRefreshContext.Provider value={value}>
      {children}
    </DataRefreshContext.Provider>
  );
};
